<%= form_with(model: dance, class: "contents", id: "dance-form") do |form| %>
  <% if dance.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-lg mt-3">
      <h2><%= pluralize(dance.errors.count, "error") %> prohibited this dance from being saved:</h2>

      <ul>
        <% dance.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

<div data-controller="info-box">
<div class="info-button">&#x24D8;</div>
<ul class="info-box">
<li>The dance name will appear on the entry forms and in various places including the final list of generated heats.
<% if dance.id %>
Changing the name here will change it everywhere.
<% end %>
<li>Categories affect where the dance appears in the agenda, and are defined on the <%= link_to "Category", categories_path, class: "x-2 rounded-lg py-1 px-2 text-white bg-blue-600 font-medium" %> page.
<% if dance.id %>
<li class="text-red-600">Removing a dance will remove it from the entry form and
<span class="font-bold">delete any heats and scores that have been entered for that dance.</span>
<% end %>
</ul>
</div>

  <div class="my-5">
    <%= form.label :name %>
    <%= form.text_field :name, class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full" %>
  </div>

  <% if @event.include_closed %>
  <div class="my-5">
    <%= form.label :closed_category_id %>
    <%= form.select :closed_category_id, @categories, { include_blank: true },
       class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full" %>
  </div>
  <% end %>

  <% if @event.include_open %>
  <div class="my-5">
    <%= form.label :open_category_id %>
    <%= form.select :open_category_id, @categories, { include_blank: true },
       class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full" %>
  </div>
  <% end %>

  <div class="my-5">
    <%= form.label :solo_category_id %>
    <%= form.select :solo_category_id, @categories, { include_blank: true },
       class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full" %>
  </div>

  <% if (@event.heat_cost || 0.0) > 0.0 %>
  <div class="my-5">
    <%= form.label :cost_override, "Cost Override (if different)" %>
    <%= form.number_field :cost_override, step: :any,
      class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full" %>
  </div>
  <% end %>

  <% if @event.dance_limit != nil %>
  <div class="my-5">
    <%= form.label :limit, "Dance limit (if different)" %>
    <%= form.number_field :limit, step: :any,
      class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full" %>
  </div>
  <% end %>
<% end %>
